export default __webpack_public_path__ + "static/media/survey.28414216.png";